import React from 'react';
import {IMaskInput} from "react-imask";
import WhatsApp from "./whatsApp";

const InputForm = ({col, mask, id, name, label, value, defaultValue, type, disabled, onBlur, onChange, onInput, onKeyDown, autoFocus, readOnly, reference, whatsApp}) => {
    const disableClas = disabled ? "bg-gray-200 text-gray-500" : "text-gray-900"
    const maskOptions = typeof mask === "object" && !Array.isArray(mask) ? mask : {mask};

    const classNameInput = "block w-full px-2.5 pb-1 pt-1 text-sm bg-transparent border-[1px] rounded-[3px] border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer h-[32px] " + disableClas;
    return (
        <div className={"flex relative " + col}>
            {
                mask &&
                <IMaskInput
                    {...maskOptions}
                    id={id}
                    name={name}
                    placeholder={""}
                    value={defaultValue ?? value}
                    type={type}
                    className={classNameInput}
                    disabled={disabled}
                    onBlur={onBlur}
                    onAccept={(valueAccepted) => {
                        if (onChange) {
                            onChange({ target: { id, name, value: valueAccepted } });
                        }
                    }}
                    onInput={onInput}
                    onKeyDown={onKeyDown}
                    autoFocus={autoFocus}
                    ref={reference}
                />
            }

            {
                !mask &&
                <input
                    id={id}
                    name={name}
                    placeholder={""}
                    defaultValue={defaultValue}
                    value={value}
                    type={type}
                    className={classNameInput}
                    disabled={disabled}
                    onBlur={onBlur}
                    onChange={onChange}
                    onInput={onInput}
                    onKeyDown={onKeyDown}
                    autoFocus={autoFocus}
                    readOnly={readOnly}
                    ref={reference}
                />

            }

            <label htmlFor={id} style={{ whiteSpace: "nowrap" }}
                   className={`absolute text-sm px-1 text-gray-500 duration-300 transform -translate-y-4 scale-75 top-[5px]
                   z-10 origin-[0] peer-placeholder-shown:-top-[2px] peer-placeholder-shown:scale-100
                   peer-placeholder-shown:translate-y-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-2.5
                   peer-focus:top-[5px] peer-focus:px-1 max-w-full truncate ${disabled ? ((value || defaultValue) ? "bg-label-disabled" : "") : "bg-white"}`}>
                {label}
            </label>

            {
                whatsApp &&
                <WhatsApp number={defaultValue ?? value} className={"whatsAppInput"}/>
            }
        </div>
    );
};

export default InputForm;
